import * as analysisOfActivity from '../services/analysisOfActivity';
import { mulTimeDimensionMulIndexMulValueType } from '@/utils/reportResponseUtil';

function getAllData(list) {
  if (list && list.length > 0) {
    return list.reduce((all, item) => all + Number(item.VALUE), 0);
  }
  return 0;
}
export default {
  namespace: 'analysisOfActivity',
  state: {
    tabValue: 0,
  },
  effects: {
    // 查询预约活动活动概览报表
    *getQueryBookingOverviewReport(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingOverviewReport,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          bookingOverviewReport: response.data,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动下单转化率报表(市场，门店)
    *getQueryBookingBuyReport(
      {
        payload: {
          values: { type, ...value },
        },
        callback,
      },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingBuyReport,
        value,
      );
      if (type === 1) {
        yield put({
          type: 'save',
          payload: {
            bookingBuyReportTop5: response.data,
          },
        });
        return;
      }
      yield put({
        type: 'save',
        payload: {
          bookingBuyReport: response.data,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动核销率报表(市场，门店，场次)
    *getQueryBookingVerificationReport(
      {
        payload: {
          values: { type, ...value },
        },
        callback,
      },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingVerificationReport,
        value,
      );
      if (type === 1) {
        yield put({
          type: 'save',
          payload: {
            sessionBookingVerificationReport: response.data,
          },
        });
        return;
      } else if (type === 2) {
        yield put({
          type: 'save',
          payload: {
            storeBookingVerificationReport: response.data,
          },
        });
        return;
      }
      yield put({
        type: 'save',
        payload: {
          bookingVerificationReport: response.data,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动核销率（市场下拉框）
    *getQueryBookingVerificationSalesArea(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingVerificationSalesArea,
        values,
      );
      const array = response.data?.map((item) => ({ name: item, value: item }));
      yield put({
        type: 'save',
        payload: {
          bookingVerificationSalesArea: array,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动新老会员累计购买报表(市场，门店)
    *getQueryBookingMemberBuyReport(
      {
        payload: {
          values: { showType, ...value },
        },
        callback,
      },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingMemberBuyReport,
        value,
      );
      if (showType === 1) {
        yield put({
          type: 'save',
          payload: {
            bookingMemberBuyReportTop5: response.data,
          },
        });
        return;
      } else if (showType === 2) {
        yield put({
          type: 'save',
          payload: {
            newBookingMemberBuyReport: response.data,
          },
        });
        return;
      } else if (showType === 3) {
        yield put({
          type: 'save',
          payload: {
            newBookingMemberBuyReportTop5: response.data,
          },
        });
        return;
      }
      yield put({
        type: 'save',
        payload: {
          bookingMemberBuyReport: response.data,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动小程序流转数据报表
    *getQueryBookingDataFlowReport(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingDataFlowReport,
        values,
      );
      const funnelData = mulTimeDimensionMulIndexMulValueType(
        response.data,
      )?.ALL;
      const funnelArray = [];
      for (let n in funnelData) {
        const v = Array.isArray(funnelData[n])
          ? funnelData[n].find((i) => i.LABEL === '全部')
          : '';
        funnelArray.push(
          { name: n, value: v?.VALUE || 0, itemStyle: { height: '15%' } },
          { name: n + 1, value: v?.VALUE || 0, itemStyle: { height: '5%' } },
        );
      }
      funnelArray.map((item, index) => {
        index === funnelArray.length - 2
          ? (item.label = { color: '#fff' })
          : (item.label = { color: '#212121' });
        return item;
      });
      const tData = [];
      for (let m in funnelData) {
        tData.push({ cName: m, list: funnelData[m] });
      }
      yield put({
        type: 'save',
        payload: {
          funnelData: funnelArray,
          bookingDataFlowReport: tData,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动分布图报表(等级分布)
    *getQueryBookingDistributionReport(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingDistributionReport,
        values,
      );
      // 等级分布(新老会员)start
      const registerSalesAreaDistribution =
        response.data.registerSalesAreaDistribution;
      const distributionData = mulTimeDimensionMulIndexMulValueType(
        registerSalesAreaDistribution,
      )?.ALL;
      const tData = [];
      for (let m in distributionData) {
        tData.push({ cName: m, list: distributionData[m] });
      }
      let newYL, oldYL, newCL, oldCL, newSL, oldSL, newXL, oldXL;
      for (let n of tData) {
        switch (n.cName) {
          case '新会员(优履会员)':
            newYL = getAllData(n.list);
            break;
          case '老会员(优履会员)':
            oldYL = getAllData(n.list);
            break;
          case '新会员(初履会员)':
            newCL = getAllData(n.list);
            break;
          case '老会员(初履会员)':
            oldCL = getAllData(n.list);
            break;
          case '新会员(奢履会员)':
            newSL = getAllData(n.list);
            break;
          case '老会员(奢履会员)':
            oldSL = getAllData(n.list);
            break;
          case '新会员(心履会员)':
            newXL = getAllData(n.list);
            break;
          case '老会员(心履会员)':
            oldXL = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barLeave = {
        source: [
          ['type', '新会员', '老会员'],
          ['初履会员', newCL, oldCL],
          ['心履会员', newXL, oldXL],
          ['优履会员', newYL, oldYL],
          ['奢履会员', newSL, oldSL],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(新老会员)end
      // 等级分布(有购买新老会员)start
      const buySalesAreaDistribution = response.data.buySalesAreaDistribution;
      const distributionDataBuy = mulTimeDimensionMulIndexMulValueType(
        buySalesAreaDistribution,
      )?.ALL;
      const tDataBuy = [];
      for (let m in distributionDataBuy) {
        tDataBuy.push({ cName: m, list: distributionDataBuy[m] });
      }
      let newYLBuy,
        oldYLBuy,
        newCLBuy,
        oldCLBuy,
        newSLBuy,
        oldSLBuy,
        newXLBuy,
        oldXLBuy;
      for (let n of tDataBuy) {
        switch (n.cName) {
          case '有购买新会员(优履)':
            newYLBuy = getAllData(n.list);
            break;
          case '有购买老会员(优履)':
            oldYLBuy = getAllData(n.list);
            break;
          case '有购买新会员(初履)':
            newCLBuy = getAllData(n.list);
            break;
          case '有购买老会员(初履)':
            oldCLBuy = getAllData(n.list);
            break;
          case '有购买新会员(奢履)':
            newSLBuy = getAllData(n.list);
            break;
          case '有购买老会员(奢履)':
            oldSLBuy = getAllData(n.list);
            break;
          case '有购买新会员(心履)':
            newXLBuy = getAllData(n.list);
            break;
          case '有购买老会员(心履)':
            oldXLBuy = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barLeaveBuy = {
        source: [
          ['type', '有购买新会员', '有购买老会员'],
          ['初履会员', newCLBuy, oldCLBuy],
          ['心履会员', newXLBuy, oldXLBuy],
          ['优履会员', newYLBuy, oldYLBuy],
          ['奢履会员', newSLBuy, oldSLBuy],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(有购买新老会员)end
      yield put({
        type: 'save',
        payload: {
          barLeave,
          barLeaveBuy,
          bookingDistributionReport: tData,
          bookingDistributionReportBuy: tDataBuy,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动分布图报表(性别分布)
    *getQueryBookingDistributionReportGender(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingDistributionReport,
        values,
      );
      // 等级分布(新老会员)start
      const registerSalesAreaDistribution =
        response.data.registerSalesAreaDistribution;
      const distributionData = mulTimeDimensionMulIndexMulValueType(
        registerSalesAreaDistribution,
      )?.ALL;
      const tData = [];
      for (let m in distributionData) {
        tData.push({ cName: m, list: distributionData[m] });
      }
      let newMale, oldMale, newFemale, oldFemale;
      for (let n of tData) {
        switch (n.cName) {
          case '新会员(女性)':
            newFemale = getAllData(n.list);
            break;
          case '老会员(女性)':
            oldFemale = getAllData(n.list);
            break;
          case '新会员(男性)':
            newMale = getAllData(n.list);
            break;
          case '老会员(男性)':
            oldMale = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barGender = {
        source: [
          ['type', '新会员', '老会员'],
          ['男性', newMale, oldMale],
          ['女性', newFemale, oldFemale],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(新老会员)end
      // 等级分布(有购买新老会员)start
      const buySalesAreaDistribution = response.data.buySalesAreaDistribution;
      const distributionDataBuy = mulTimeDimensionMulIndexMulValueType(
        buySalesAreaDistribution,
      )?.ALL;
      const tDataBuy = [];
      for (let m in distributionDataBuy) {
        tDataBuy.push({ cName: m, list: distributionDataBuy[m] });
      }
      let newMaleBuy, oldMaleBuy, newFemaleBuy, oldFemaleBuy;
      for (let n of tDataBuy) {
        switch (n.cName) {
          case '有购买新会员(女)':
            newFemaleBuy = getAllData(n.list);
            break;
          case '有购买老会员(女)':
            oldFemaleBuy = getAllData(n.list);
            break;
          case '有购买新会员(男)':
            newMaleBuy = getAllData(n.list);
            break;
          case '有购买老会员(男)':
            oldMaleBuy = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barGenderBuy = {
        source: [
          ['type', '有购买新会员', '有购买老会员'],
          ['男性', newMaleBuy, oldMaleBuy],
          ['女性', newFemaleBuy, oldFemaleBuy],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(有购买新老会员)end
      yield put({
        type: 'save',
        payload: {
          barGender,
          barGenderBuy,
          bookingDistributionReportGender: tData,
          bookingDistributionReportBuyGender: tDataBuy,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    // 查询预约活动分布图报表(性别分布)
    *getQueryBookingDistributionReportAge(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        analysisOfActivity.getQueryBookingDistributionReport,
        values,
      );
      // 等级分布(新老会员)start
      const registerSalesAreaDistribution =
        response.data.registerSalesAreaDistribution;
      const distributionData = mulTimeDimensionMulIndexMulValueType(
        registerSalesAreaDistribution,
      )?.ALL;
      const tData = [];
      for (let m in distributionData) {
        tData.push({
          cName: m,
          list: distributionData[m],
          sort: m === '新会员(<10)' || m === '老会员(<10)' ? 2 : 1,
        });
      }
      tData.sort((a, b) => b.sort - a.sort);
      let newVip01,
        oldVip01,
        newVip10,
        oldVip10,
        newVip20,
        oldVip20,
        newVip30,
        oldVip30,
        newVip40,
        oldVip40,
        newVip50,
        oldVip50,
        newVip60,
        oldVip60;
      for (let n of tData) {
        switch (n.cName) {
          case '新会员(<10)':
            newVip01 = getAllData(n.list);
            break;
          case '老会员(<10)':
            oldVip01 = getAllData(n.list);
            break;
          case '新会员(10~19)':
            newVip10 = getAllData(n.list);
            break;
          case '老会员(10~19)':
            oldVip10 = getAllData(n.list);
            break;
          case '新会员(20~29)':
            newVip20 = getAllData(n.list);
            break;
          case '老会员(20~29)':
            oldVip20 = getAllData(n.list);
            break;
          case '新会员(30~39)':
            newVip30 = getAllData(n.list);
            break;
          case '老会员(30~39)':
            oldVip30 = getAllData(n.list);
            break;
          case '新会员(40~49)':
            newVip40 = getAllData(n.list);
            break;
          case '老会员(40~49)':
            oldVip40 = getAllData(n.list);
            break;
          case '新会员(50~59)':
            newVip50 = getAllData(n.list);
            break;
          case '老会员(50~59)':
            oldVip50 = getAllData(n.list);
            break;
          case '新会员(≥60)':
            newVip60 = getAllData(n.list);
            break;
          case '老会员(≥60)':
            oldVip60 = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barAge = {
        source: [
          ['type', '新会员', '老会员'],
          ['<10', newVip01, oldVip01],
          ['10-19', newVip10, oldVip10],
          ['20-29', newVip20, oldVip20],
          ['30-39', newVip30, oldVip30],
          ['40-49', newVip40, oldVip40],
          ['50-59', newVip50, oldVip50],
          ['≥60', newVip60, oldVip60],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(新老会员)end
      // 等级分布(有购买新老会员)start
      const buySalesAreaDistribution = response.data.buySalesAreaDistribution;
      const distributionDataBuy = mulTimeDimensionMulIndexMulValueType(
        buySalesAreaDistribution,
      )?.ALL;
      const tDataBuy = [];
      for (let m in distributionDataBuy) {
        tDataBuy.push({
          cName: m,
          list: distributionDataBuy[m],
          sort: m === '有购买新会员(<10)' || m === '有购买老会员(<10)' ? 2 : 1,
        });
      }
      tDataBuy.sort((a, b) => b.sort - a.sort);
      let newVipBuy01,
        oldVipBuy01,
        newVipBuy10,
        oldVipBuy10,
        newVipBuy20,
        oldVipBuy20,
        newVipBuy30,
        oldVipBuy30,
        newVipBuy40,
        oldVipBuy40,
        newVipBuy50,
        oldVipBuy50,
        newVipBuy60,
        oldVipBuy60;
      for (let n of tDataBuy) {
        switch (n.cName) {
          case '有购买新会员(<10)':
            newVipBuy01 = getAllData(n.list);
            break;
          case '有购买老会员(<10)':
            oldVipBuy01 = getAllData(n.list);
            break;
          case '有购买新会员(10~19)':
            newVipBuy10 = getAllData(n.list);
            break;
          case '有购买老会员(10~19)':
            oldVipBuy10 = getAllData(n.list);
            break;
          case '有购买新会员(20~29)':
            newVipBuy20 = getAllData(n.list);
            break;
          case '有购买老会员(20~29)':
            oldVipBuy20 = getAllData(n.list);
            break;
          case '有购买新会员(30~39)':
            newVipBuy30 = getAllData(n.list);
            break;
          case '有购买老会员(30~39)':
            oldVipBuy30 = getAllData(n.list);
            break;
          case '有购买新会员(40~49)':
            newVipBuy40 = getAllData(n.list);
            break;
          case '有购买老会员(40~49)':
            oldVipBuy40 = getAllData(n.list);
            break;
          case '有购买新会员(50~59)':
            newVipBuy50 = getAllData(n.list);
            break;
          case '有购买老会员(50~59)':
            oldVipBuy50 = getAllData(n.list);
            break;
          case '有购买新会员(≥60)':
            newVipBuy60 = getAllData(n.list);
            break;
          case '有购买老会员(≥60)':
            oldVipBuy60 = getAllData(n.list);
            break;
          default:
            break;
        }
      }
      const barAgeBuy = {
        source: [
          ['type', '有购买新会员', '有购买老会员'],
          ['<10', newVipBuy01, oldVipBuy01],
          ['10-19', newVipBuy10, oldVipBuy10],
          ['20-29', newVipBuy20, oldVipBuy20],
          ['30-39', newVipBuy30, oldVipBuy30],
          ['40-49', newVipBuy40, oldVipBuy40],
          ['50-59', newVipBuy50, oldVipBuy50],
          ['≥60', newVipBuy60, oldVipBuy60],
        ],
        series: [{ type: 'bar' }, { type: 'bar' }],
      };
      // 等级分布(有购买新老会员)end
      yield put({
        type: 'save',
        payload: {
          barAge,
          barAgeBuy,
          bookingDistributionReportAge: tData,
          bookingDistributionReportBuyAge: tDataBuy,
        },
      });
      if (callback & (typeof callback === 'function')) {
        return callback(response);
      }
    },
    *getQueryBookingSaleReport({ payload: { values } }, { call, put }) {
      const response = yield call(
        analysisOfActivity.getQueryBookingSaleReport,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          salesAreaList: response.data?.salesAreaList?.map((item) => ({
            name: item,
            value: item,
          })),
          saleShoesList: response.data?.saleShoesList,
          saleOtherList: response.data?.saleOtherList,
        },
      });
    },
    // 点击tab
    *changeTab({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          tabValue: values.tab,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/marketing/appoint_activity/analysis_of_activity'
        ) {
          dispatch({
            type: 'save',
            payload: {
              tabValue: 0,
            },
          });
        }
      });
    },
  },
};
